(function (root, factory) {
    const pluginName = 'CarouselPlugin';

    // eslint-disable-next-line no-undef
    if (typeof define === 'function' && define.amd) {
        // eslint-disable-next-line no-undef
        define([], factory(pluginName));
    } else if (typeof exports === 'object') {
        module.exports = factory(pluginName);
    } else {
        root[pluginName] = factory(pluginName);
    }
// eslint-disable-next-line no-unused-vars
}(this, (pluginName) => {
    const getResponsiveSettings = (breakpoint, slideCount) => {
        return {
            breakpoint,
            settings: {
                arrows: false,
                centerMode: false,
                slidesToShow: slideCount,
                slidesToScroll: slideCount,
            },
        };
    };

    const initSlick = function (row) {
        const crossCellSlidesCount = $('.c-collection__col').length;
        const isHedThemeEnabled = ACC.utils.isHedTheme();

        const slidesToShowDependOnSlidesCount = (slideCount) => {
            return (slideCount === 2 || slideCount === 1) ? slideCount : 3;
        };
        const responsiveSettingsLearnerTheme = [
            getResponsiveSettings(1025, slidesToShowDependOnSlidesCount(crossCellSlidesCount)),
        ];
        const responsiveSettingsHedTheme = [getResponsiveSettings(1023, 2)];
        const responsiveSettings = isHedThemeEnabled ? responsiveSettingsHedTheme : responsiveSettingsLearnerTheme;
        const settings = {
            infinite: true,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            accessibility: true,
            arrows: false,
            dots: crossCellSlidesCount >= 4,
            responsive: responsiveSettings,
        };
        const settingsHedTheme = {
            infinite: true,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 3,
            accessibility: false,
            arrows: false,
            appendDots: '.js-dots',
            dots: crossCellSlidesCount >= 4,
            responsive: responsiveSettings,
        };

        row.slick(isHedThemeEnabled ? settingsHedTheme : settings);
    };

    /**
     * Remove aria-current attribute from dots
     * @param {object} dots
     * @function
     */
    const removeAriaCurrentAttributes = function (dots) {
        dots.removeAttr('aria-current');
    };

    /**
     * Set aria-current attribute
     * @param {object} dot
     * @function
     */
    const setAriaCurrentAttribute = function (dot) {
        dot.setAttribute('aria-current', 'true');
    };

    /**
     * Set aria-current attribute
     * @param {object} dot
     * @function
     */
    const handleAriaCurrentAttributes = function (dot) {
        const item = dot.parentNode;
        const isActiveItem = item.classList.contains('slick-active');

        if (isActiveItem) {
            setAriaCurrentAttribute(dot);
        }
    };

    const handler = function (row) {
        $(window)
            .on('load resize', () => {
                const $windowWidth = $(window)
                    .width();

                if ($windowWidth < 768) {
                    if (row.hasClass('slick-initialized')) {
                        row.slick('unslick');
                    }
                } else if (!row.hasClass('slick-initialized')) {
                    initSlick(row);
                }
            });

        const dots = $('.cross-sell .slick-dots button');

        [].forEach.call(dots, (dot, index) => {
            if (ACC.utils.isHedTheme()) {
                handleAriaCurrentAttributes(dot);
                dot.setAttribute('aria-label', `Recommendations Page ${index + 1}`);
            } else {
                dot.setAttribute('aria-label', `Recommendations Page ${dot.getAttribute('aria-label')}`);
            }
        });

        if (ACC.utils.isHedTheme()) {
            row.on('afterChange', () => {
                removeAriaCurrentAttributes(dots);

                [].forEach.call(dots, (dot) => {
                    handleAriaCurrentAttributes(dot);
                });
            });
        }
    };

    /**
     * Plugin Object
     * @constructor
     */
    function Plugin(element) {
        // Initialize cross-cell component
        this.init(element);
    }

    /**
     * Plugin prototype
     * @public
     * @constructor
     */
    Plugin.prototype = {
        init(element) {
            initSlick(element);
            handler(element);
        },
    };

    return Plugin;
}));
